import { render, staticRenderFns } from "./CompaniesAssign.vue?vue&type=template&id=f0c06f96"
import script from "./CompaniesAssign.vue?vue&type=script&lang=ts"
export * from "./CompaniesAssign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports